import { useEffect } from 'react';
import useWindowDimensions from '../hooks/useWindowDimensions';
import { useBooking } from '../contexts/ticketBookingContext/TicketBookingContext';

function DesktopWatcher() {
  const { width } = useWindowDimensions();
  const { isDesktop, setIsDesktop } = useBooking();

  useEffect(() => {
    if (width > 1024 && !isDesktop) {
      setIsDesktop(true);
    }
    if (width < 1025 && isDesktop) {
      setIsDesktop(false);
    }
  }, [width]);
  return null;
}

export default DesktopWatcher;
